<div
  *ngIf="isAvailable"
  [class.active]="isActive"
  [class.with-label]="label"
  [class.with-counter]="counter !== undefined"
  [class.with-icon]="iconName"
  class="button-container"
>
  <ng-container *ngIf="type === 'view-switcher'">
    <div *ngIf="iconName" class="icon-container">
      <rt-icon [name]="iconName" [size]="'small'"></rt-icon>
    </div>
    <div *ngIf="label" class="label-container">
      {{ label }}
    </div>
    <rt-badge
      *ngIf="counter !== undefined && counter !== null"
      color="counter-light"
      [text]="counter"
    ></rt-badge>
  </ng-container>
  <div *ngIf="type === 'multilang-switcher'" class="multilang-container">
    <ng-container *ngIf="language.primary">
      <div class="text">
        {{ language.name }}
        <span> ({{ primaryLanguageLabel | translate }})</span>
      </div>
    </ng-container>
    <ng-container *ngIf="!language.primary">
      <div class="text">{{ language.name }}</div>
      <div *ngIf="loadingLanguageCode === language.code" layout-centered class="spinner-wrap">
        <rt-spinner variant="small"></rt-spinner>
      </div>
      <rt-circular-progress-indicator
        *ngIf="!language.primary && loadingLanguageCode !== language.code"
        [percent]="getTranslationProgress(language.translationFieldsCount)"
        [rtTooltip]="getTooltipMessage(language.translationFieldsCount)"
        margin-left-small-x
      >
      </rt-circular-progress-indicator>
    </ng-container>
  </div>
</div>
